import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'vfa-cp-impressum-dialog',
  templateUrl: './impressum-dialog.component.html',
  styleUrls: ['./impressum-dialog.component.scss']
})
export class ImpressumModal implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {

  }

  public closeModal() {
    this.dialog.closeAll();
  }

}

